import { useState, type VoidFunctionComponent } from 'react';

import Accordion from '../generic/Accordion';
import Card from '../generic/Card/Card';
import Flex from '../generic/Flex';

import SyncSearcherPackages from './SyncSearcherPackages';

type Props = {
  isOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
};

/**
 * Section grouping manually-triggered background jobs (e.g. searcher package sync).
 */
export const ManualJobsCard: VoidFunctionComponent<Props> = ({ isOpen, onToggle }) => {
  const [isSectionOpen, setIsSectionOpen] = useState(isOpen ?? false);
  const handleToggle = () => {
    setIsSectionOpen(!isSectionOpen);
    onToggle?.(isSectionOpen);
  };

  return (
    <Card isFullWidth padding="medium">
      <Card.Content>
        <Accordion id="manual-jobs" isInitiallyOpen={isSectionOpen}>
          <Accordion.Target onClick={handleToggle}>Manual Jobs</Accordion.Target>
          <Accordion.Body>
            <Flex direction="column" gap={12}>
              <SyncSearcherPackages />
            </Flex>
          </Accordion.Body>
        </Accordion>
      </Card.Content>
    </Card>
  );
};
